import React from 'react';
import { ModeContext } from '@/contexts/ModeContext';
import { logError } from '@utils/usefulFuncs';
import styled from 'styled-components';
import { Modal } from '@ui';
import { Body5, Container } from '@ui';
import { Separator } from '@ui';
import { Header } from './components/Header';
import { ModeSelectBar } from './components/ModeSelectBar';
import { DOCUMENT_SELECTION_MODES } from './modes';
import { UploadedDocumentsSelection } from './modes/MyUploadsDocumentSelection';
import { CompanyDocumentSelection } from './modes/CompanyDocumentSelection';
import {
  WebsiteDocumentSelection,
  MacroDocumentSelection,
  CustomDocumentSelection,
  PresetModeDocumentSelection,
  CompanyTagModeSelection,
  SpeakerModeSelection,
} from './modes/legacyAdapters';

const ModeContentWrapper = styled.div``;

const modalProps = {
  maximizeWidth: true,
  forceHeight: true,
};

export const DocumentSelectionModal = ({
  headingText,
  headerAction = null,
  onDismiss,
  documentSelectionModes: documentSelectionModesProp,
  defaultActiveMode: defaultActiveModeProp,
  docMode,
  tool,
  singleDocMode = false,
}) => {
  const { defaultActiveDocumentSelectionMode, documentSelectionModes: documentSelectionModesContext = [] } =
    React.useContext(ModeContext);

  // Modes may be supplied via props (NewQueryTool and the other tool surfaces) or
  // via ModeContext (GenericQuery and the template/reasoning pages).
  const documentSelectionModes = documentSelectionModesProp || documentSelectionModesContext;
  const [docSelectMode, setDocSelectMode] = React.useState(
    defaultActiveModeProp || defaultActiveDocumentSelectionMode || documentSelectionModes[0]
  );

  if (documentSelectionModes.length === 0) {
    logError('documentSelectionModes is not set');
    return null;
  }

  const onModeChange = (mode) => setDocSelectMode(mode);

  const renderActiveModeContent = (mode) => {
    switch (mode) {
      case DOCUMENT_SELECTION_MODES.myDocs:
        return <UploadedDocumentsSelection singleDocMode={singleDocMode} />;
      case DOCUMENT_SELECTION_MODES.allCompany:
        return <CompanyDocumentSelection singleDocMode={singleDocMode} />;
      case DOCUMENT_SELECTION_MODES.companyTag:
        return <CompanyTagModeSelection />;
      case DOCUMENT_SELECTION_MODES.speaker:
        return <SpeakerModeSelection />;
      case DOCUMENT_SELECTION_MODES.website:
        return <WebsiteDocumentSelection />;
      case DOCUMENT_SELECTION_MODES.fedDoc:
        return <MacroDocumentSelection />;
      case DOCUMENT_SELECTION_MODES.customMode:
        return <CustomDocumentSelection tool={tool} />;
      case DOCUMENT_SELECTION_MODES.docType:
        return <PresetModeDocumentSelection presetParams={{ docMode }} onDismiss={onDismiss} />;
      case DOCUMENT_SELECTION_MODES.client:
        return <PresetModeDocumentSelection presetParams={{ docMode }} onDismiss={onDismiss} />;
      case DOCUMENT_SELECTION_MODES.ppm:
        return <PresetModeDocumentSelection presetParams={{ docMode: 'ppm' }} onDismiss={onDismiss} />;
      case DOCUMENT_SELECTION_MODES.credit:
        return <PresetModeDocumentSelection presetParams={{ docMode: 'credit' }} onDismiss={onDismiss} />;
      default:
        return <Body5>No content available for this mode</Body5>;
    }
  };

  return (
    <Modal onDismiss={onDismiss} modalProps={modalProps}>
      <Header text={headingText} onDismiss={onDismiss} />
      {headerAction}
      <Container top={28}>
        <ModeSelectBar activeMode={docSelectMode} modes={documentSelectionModes} onModeChange={onModeChange} />
      </Container>
      <Container top={24} bottom={16}>
        <Separator />
      </Container>
      <ModeContentWrapper>{renderActiveModeContent(docSelectMode)}</ModeContentWrapper>
    </Modal>
  );
};
